import type { DataSetExtra, IPRChartContext } from "./d";
import {
  getWellFlowingPressureUsingComposite,
  getMaxFlowRateComposite,
  getWellFlowingPressure
} from "../../calculations/ipr";
import { Flow_Model_Enum } from "gql/api";

export const getCompositeDataset = (context: IPRChartContext): DataSetExtra => {
  const {
    wellProperties,
    wellTestFlowRates,
    fluidPropertiesAtReservoir,
    iterations,
    targetLiquidFlowUnit,
    targetPressureUnit,
    desiredLiquidRateSTBD
  } = context;
  const operatingPoint = {
    label: "Operating Point",
    point: { x: 0, y: 0 }
  };
  if (!wellProperties) return { points: [], operatingPoint };
  operatingPoint.point = {
    x: targetLiquidFlowUnit.toThisUnit(desiredLiquidRateSTBD),
    y: targetPressureUnit.toThisUnit(
      getWellFlowingPressure(
        Flow_Model_Enum.Composite,
        desiredLiquidRateSTBD,
        wellTestFlowRates.liquidFlowRateSTBD,
        wellProperties.well_test_static_bottom_hole_pressure_psia,
        wellProperties.well_test_producing_bottom_hole_pressure_psia,
        fluidPropertiesAtReservoir.bubblePointPressurePSIA,
        wellTestFlowRates.waterCutRatio
      )
    )
  };
  const step =
    getWellFlowingPressureUsingComposite(
      1,
      wellProperties.well_test_producing_bottom_hole_pressure_psia,
      wellProperties.well_test_static_bottom_hole_pressure_psia,
      fluidPropertiesAtReservoir.bubblePointPressurePSIA,
      wellTestFlowRates.liquidFlowRateSTBD,
      wellTestFlowRates.waterCutRatio
    ) / iterations;

  return {
    title: "Composite",
    xAxisLabel: `Flow (${
      targetLiquidFlowUnit.shortLabel || targetLiquidFlowUnit.label
    })`,
    yAxisLabel: `Pressure (${
      targetPressureUnit.shortLabel || targetPressureUnit.label
    })`,
    points: Array.from({ length: iterations })
      .map((_, i) => {
        const y = step * i;
        const x = getMaxFlowRateComposite(
          y,
          wellProperties.well_test_producing_bottom_hole_pressure_psia,
          wellProperties.well_test_static_bottom_hole_pressure_psia,
          fluidPropertiesAtReservoir.bubblePointPressurePSIA,
          wellTestFlowRates.liquidFlowRateSTBD,
          wellTestFlowRates.waterCutRatio
        );
        return {
          x: targetLiquidFlowUnit.toThisUnit(x) || x,
          y: targetPressureUnit.toThisUnit(y) || y
        };
      })
      .filter(pt => pt.x > 0)
      .filter(pt => pt.y > 0),
    operatingPoint
  };
};
